import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { KENDO_LABELS, LabelComponent } from '@progress/kendo-angular-label';
@Component({
    selector: 'gd-rvlabel',
    template: `
    <div [formGroup]="form">
      <kendo-label [attr.for]="field.label" style="font-size:12px">{{
        field.value
      }}</kendo-label>
      <kendo-label *ngIf="field.name === 'clientdob'" style="font-size:12px">{{
        getPrimaryAge()
      }}</kendo-label>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        LabelComponent,
        KENDO_INPUTS,
        KENDO_LABELS,
        NgIf,
    ]
})
export class RvLabelComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }
  getPrimaryAge(): string {
    const dob = this.form.get('clientdob').value
    const years = this.calculateAge(new Date(dob))
    return years + 'yo'
  }
  calculateAge(date: Date): number {
    const millisecDifference = Date.now() - new Date(date).getTime()
    const millisecPerDay = 24 * 60 * 60 * 1000
    const millisecPerYear = 365.25 * millisecPerDay

    const yearDifference = Math.floor(millisecDifference / millisecPerYear)
    return yearDifference
  }
}
